export const VALUE_PROP_CREDIT_CARD = {
  id: '5',
  title: 'Credit Card for Cash Fund',
  desktopImageUrl: 'https://withjoy.com/assets/public/shop/value-props3/ValuePropCardCC4CDesktop.png',
  mobileImageUrl: 'https://withjoy.com/assets/public/shop/value-props3/ValuePropCardCC4CMobile.png',
};

export const VALUE_PROP_CARDS_PER_PAGE = 2;

// TODO: Consider moving this to storefront.config
// On how many pages the cards will be displayed
export const VALUE_PROP_CARDS_PAGES_COUNT = Math.ceil(4 / VALUE_PROP_CARDS_PER_PAGE);
